import {useEffect, useState} from "react";

// Sekmeler unmount olmadığı ve sayfa değişiminde tablo yeniden kurulmadığı için
// genişletilmiş satırlar sekmeden çıkıldığında ya da sayfa değiştiğinde elle kapatılıyor
export const useCollapsibleRows = ({isTabOpened, page}) => {
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);

    useEffect(() => {
        setExpandedRowKeys([]);
    }, [isTabOpened, page]);

    return {expandedRowKeys, onExpandedRowsChange: setExpandedRowKeys};
};
